import t from "../../../i18n/i18n";
import DefRoutes from "../../../routes/routes.json";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import Notify from "../../../components/notification/notify";
import useApi from "../../../services/api";
import { handleApiErrors } from "../../../utils/handleErrors";
import { SignIn as SignInStore } from "../../../store/reducers/auth.reducer";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import GoogleLogin from "react-google-login";

import "./styles.css";
import { useRef } from "react";
import { getScreenCordinates } from "../../../utils/getScreenCordinates";
import { useCallback } from "react";

export const AppSignIn = () => {
  const { ApiSignIn, ApiSignInWithProvider } = useApi();
  const scrollTargetRef = useRef(null);

  const { push } = useHistory();

  const dispatch = useDispatch();
  const [form, setForm] = useState({ tfaAuthorization: !!localStorage.getItem("@TFA/Authorization") });

  function handleInputChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function SignInSubmit(e) {
    e.preventDefault();

    if (!form.login) return Notify({ type: "danger", message: t("Errors.EmptyLogin") });
    if (!form.password) return Notify({ type: "danger", message: t("Errors.EmptyPassword") });

    const { data } = await ApiSignIn(form);

    if (data.errors) {
      return handleApiErrors(data.errors);
    }

    if (data.tfa) {
      return push(DefRoutes.TFA, { ...data, redirectTo: DefRoutes.App.Profile });
    }

    dispatch(SignInStore(data));

    return push(DefRoutes.App.Profile);
  }

  async function SubmitFacebook({ userID, name, email, picture, accessToken }) {
    if (!userID) return;

    const params = {
      provider_id: userID,
      tfaAuthorization: !!localStorage.getItem("@TFA/Authorization"),
      nickname: form.nickname,
      facebook_id: userID,
      name,
      email,
      avatar: picture?.data?.is_silhouette ? undefined : picture?.data?.url,
      password: accessToken,
    };

    const { data } = await ApiSignInWithProvider(params);

    if (data.errors) {
      return handleApiErrors(data.errors);
    }

    if (data.tfa) {
      return push(DefRoutes.TFA, { ...data, redirectTo: DefRoutes.App.Profile });
    }

    dispatch(SignInStore(data));

    return push(DefRoutes.App.Profile);
  }

  async function SubmitGoogle({ accessToken, googleId, profileObj: { name, email, imageUrl } }) {
    if (!googleId) return;

    const params = {
      provider_id: googleId,
      tfaAuthorization: !!localStorage.getItem("@TFA/Authorization"),
      nickname: form.nickname,
      google_id: googleId,
      name,
      email,
      avatar: imageUrl,
      password: accessToken,
    };

    const { data } = await ApiSignInWithProvider(params);

    console.log(data);

    if (data.errors) {
      return handleApiErrors(data.errors);
    }

    if (data.tfa) {
      return push(DefRoutes.TFA, { ...data, redirectTo: DefRoutes.App.Profile });
    }

    dispatch(SignInStore(data));

    return push(DefRoutes.App.Profile);
  }

  const scrollToContent = useCallback(() => {
    const scrollTo = getScreenCordinates(scrollTargetRef.current);
    window.scrollTo(0, scrollTo.y - 2);
  }, []);

  return (
    <div className="separate-login-bg">
      <div className="login-main-warp">
        <div className="login-top-warp">
          <img onLoad={scrollToContent} src="/images/dd-tank-logo.png" alt="" />
        </div>
        <div className="login-form-warp">
          <div ref={scrollTargetRef} className="login-form-inside">
            <div className="separate-login-main-box">
              <div className="login-header" style={{ background: `url(..${t("Images.A022")}) no-repeat center top` }}>
                <div className="header-inside">
                  <div className="header-title">
                    <span className="icon">
                      <img src="/images/user-ico.png" alt="" />
                    </span>
                    <h3>{t("SignIn.SignIn")}</h3>
                  </div>
                  <a href={DefRoutes.SignUp} rel="noreferrer" target="_blank" className="header-register"></a>
                </div>
              </div>
              <div className="login-form-box">
                <form onSubmit={SignInSubmit}>
                  <div className="input-box type-text">
                    <input
                      type="text"
                      placeholder={t("SignIn.Form.User")}
                      name="login"
                      value={form.login || ""}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="input-box type-text">
                    <input
                      type="password"
                      placeholder={t("SignIn.Form.Password")}
                      name="password"
                      value={form.password || ""}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="input-box g-captcha"></div>
                  <div className="input-box type-btn">
                    <a href={DefRoutes.RecoveryPassword} rel="noreferrer" target="_blank">
                      <button type="button" className="btn-esqueci">
                        {t("SignIn.ForgotPassword")}
                      </button>
                    </a>
                    <button type="submit" className="btn-fazer">
                      {t("SignIn.Form.Submit")}
                    </button>
                  </div>
                  <div className="input-box type-social-btn">
                    <h5>{t("SignIn.OtherOptions")}</h5>
                    <FacebookLogin
                      appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                      fields="name,email,picture"
                      callback={SubmitFacebook}
                      render={(renderProps) => (
                        <button type="button" onClick={renderProps.onClick}>
                          <img src="/images/facebook-m.png" alt="" />
                        </button>
                      )}
                    />

                    <GoogleLogin
                      clientId={process.env.REACT_APP_GOOGLE_APP_ID}
                      render={(renderProps) => (
                        <button type="button" onClick={renderProps.onClick} disabled={renderProps.disabled}>
                          <img src="/images/google-m.png" alt="" />
                        </button>
                      )}
                      buttonText="Login"
                      onSuccess={SubmitGoogle}
                      onFailure={(e) => console.log(e)}
                      cookiePolicy={"single_host_origin"}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="shap-style-left">
            <img src="/images/login-logo.png" alt="" />
          </div>
          <div className="shap-style-right">
            <img src="/images/login-logo-right.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppSignIn;
